import React from 'react'
import CMSContent from '../cms-content'
import {TYPE_CONTENT_SLOT} from '../cms-content/hooks/use-cms-content'

const HeaderContent = () => {
    return <CMSContent id="header-content" type={TYPE_CONTENT_SLOT} showError={false} />
}

export const HeaderContentHomePage = () => {
    return <CMSContent id="header-content-homepage" type={TYPE_CONTENT_SLOT} showError={false} />
}

export default HeaderContent
